import React, { useEffect,useState  } from 'react';
import { msalInstance } from './msalConfig';
import { Route, useHistory } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Admin } from './components/Admin';
import { Home } from './components/Home';


 const AuthRouteWrapper = ({ component: Component, isPrivate, ...rest }) => {
  const history = useHistory();
const [graphData1, setGraphData]= useState({});
const [AccessToken1, setAccessToken]= useState("");

  const { instance, accounts } = useMsal();
  useEffect(() => {
    const login = async () => {
      try {
       
        console.log("accounts",accounts.length)
        const apirequest = {
                   // Replace with the desired API scopes
                   scopes:['User.Read']
                  };
                 const backendrequest={
                     scopes: ['https://cleverantdownload.deloitte.ca/user_impersonation']
                 }
            
        if (accounts.length === 0) {
          // Redirect to the login page if the user is not authenticated
          const loginResponse =  await msalInstance.loginPopup();
          const account = loginResponse && loginResponse.account;
          if (account) {
            instance.setActiveAccount(account);
          }
        }
        const response = await instance.acquireTokenSilent(apirequest);
        const backendresponse=await instance.acquireTokenSilent(backendrequest);
        const backendaccessToken=backendresponse.accessToken;
        const accessToken = response.accessToken;
        console.log('backend Access Token:', backendaccessToken);
         console.log('Access Token:', accessToken);
         setAccessToken(backendaccessToken);
         const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me/memberOf?$top=500', {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
        const graphData = await graphResponse.json();
        setGraphData(graphData);
        console.log('Graph API response:', graphData);
        console.log('Graphdata1:', graphData1);
     
        
      } catch (error) {
        console.log('Authentication error:', error);
      }
    };

    if (isPrivate) {
      login();
    }
  }, [isPrivate]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isPrivate ? (
          graphData1 && Object.keys(graphData1).length !== 0 ? (
            <Admin {...props} loginUserADGroups={graphData1} loginUserAccessToken={AccessToken1} />
          ) : (
            "LOADING"
          )
        ) : (
          <Component {...props} />
        )
      }
    />
  )
    // <Route
    //   {...rest}
    //   render={(props) =>
    //     isPrivate ?
    //     //  (
    //     //    <Component {...props} loginUserADGroups={graphData1}/>
       
    //     // ) 
    //    ( {graphData1}!={}?<Admin {...props} loginUserADGroups={graphData1}/>:"LOADING")
    //     : (
    //       <Component {...props} />
    //     )
    //   }
    // />);
};


export default AuthRouteWrapper;



